import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaYoutube, FaSpotify } from "react-icons/fa";
import logo from "../assets/images/logodel.svg";
import "./styles/Footer.scss";

const currentYear = new Date().getFullYear();

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand">
          <Link to="/" className="footer__logo-link">
            <img src={logo} alt="Del Music Foundation" className="footer__logo" />
          </Link>
          <p className="footer__tagline">
            Empowering the next generation through the love of music and education.
          </p>
          <div className="footer__social">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <FaYoutube />
            </a>
            <a href="https://spotify.com" target="_blank" rel="noopener noreferrer" aria-label="Spotify">
              <FaSpotify />
            </a>
          </div>
        </div>

        <nav className="footer__nav">
          <div className="footer__col">
            <h4>Explore</h4>
            <Link to="/">Home</Link>
            <Link to="/About">About</Link>
            <Link to="/AdvisoryBoard">Advisory Board</Link>
            <Link to="/success-stories">Success Stories</Link>
          </div>
          <div className="footer__col">
            <h4>Get involved</h4>
            <Link to="/Donations">Donate</Link>
            <Link to="/Contact">Contact Us</Link>
            <Link to="/Media">Media</Link>
            <Link to="/faq">FAQ</Link>
          </div>
          <div className="footer__col">
            <h4>Visit</h4>
            <address>
              3704 16th Ave E.<br />
              Palmetto, FL 34221
            </address>
            <p className="footer__tax">501(c)(3) nonprofit<br />EIN: 13-6089816</p>
          </div>
        </nav>
      </div>

      <div className="footer__bottom">
        <p>© {currentYear} Del Couch Music Education Foundation. All rights reserved.</p>
        <div className="footer__legal">
          <Link to="/Privacy">Privacy Policy</Link>
          <span>•</span>
          <Link to="/Terms">Terms of Use</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
